import { render } from "./OurPartner.vue?vue&type=template&id=322515ba&ts=true"
import script from "./OurPartner.vue?vue&type=script&lang=ts"
export * from "./OurPartner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__